var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelMbl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00781 9.43066C0.742188 9.69629 0.734375 10.1494 1.00781 10.4229C1.27344 10.6963 1.73438 10.6885 2 10.4229L6 6.41504L10.0078 10.4229C10.2734 10.6885 10.7266 10.6963 10.9922 10.4229C11.2734 10.1494 11.2656 9.69629 10.9922 9.43066L6.99219 5.42285L10.9922 1.42285C11.2656 1.15723 11.2734 0.696289 10.9922 0.430664C10.7266 0.157227 10.2734 0.165039 10.0078 0.430664L6 4.43848L2 0.430664C1.73438 0.165039 1.27344 0.157227 1.00781 0.430664C0.734375 0.696289 0.742188 1.15723 1.00781 1.42285L5.01562 5.42285L1.00781 9.43066Z",
    fill: "#1A2C4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelMbl);
export default __webpack_public_path__ + "static/media/cancel_mbl.6d16a0e46a31e5b70c23457989c7f28f.svg";
export { ForwardRef as ReactComponent };